import React from 'react';
import { useNavigate } from 'react-router-dom';

export function TermsPage() {
  const navigate = useNavigate();

  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      {/* Back Button */}
      <button
        onClick={() => navigate(-1)}
        className="flex items-center gap-2 text-gray-600 hover:text-gray-900 mb-6 transition-colors"
      >
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
        </svg>
        Back
      </button>

      <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">Terms & Conditions</h1>
        <p className="text-gray-600 mb-8">Effective Date: December 3rd, 2025</p>
        <p className="text-gray-600 mb-8">Platform: The Daily Do ("we," "our," "us")</p>

        <div className="prose prose-gray max-w-none space-y-6">
          {/* Section 1 */}
          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">1. Acceptance of Terms</h2>
            <p className="text-gray-700 leading-relaxed">
              By accessing or using The Daily Do website or services (the "Platform"), you agree to be bound by these Terms & Conditions ("Terms"). If you do not agree, please do not use our Platform.
            </p>
          </section>

          {/* Section 2 */}
          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">2. Platform Role & Disclaimer</h2>
            <p className="text-gray-700 leading-relaxed mb-3">
              The Daily Do provides a platform for users, organizers, and businesses to share and discover events. We are not the organizer, producer, or sponsor of any events listed on our Platform, unless explicitly stated otherwise.
            </p>
            <p className="text-gray-700 leading-relaxed mb-3">
              We do not endorse, guarantee, or verify the quality, safety, legality, accuracy, or suitability of any event.
            </p>
            <p className="text-gray-700 leading-relaxed">
              Attendance at events is at your own risk. You should carefully evaluate all information before participating.
            </p>
          </section>

          {/* Section 3 */}
          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">3. User Responsibilities</h2>
            <ul className="list-disc pl-6 space-y-2 text-gray-700">
              <li>You must be at least 13 years old to use the Platform (or older if required by your jurisdiction).</li>
              <li>You agree not to post any unlawful, misleading, defamatory, or harmful content.</li>
              <li>You are solely responsible for the content you share and any events you organize or attend.</li>
            </ul>
          </section>

          {/* Section 4 */}
          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">4. Event Listings</h2>
            <p className="text-gray-700 leading-relaxed">
              By submitting an event to The Daily Do, you grant us a non-exclusive, worldwide, royalty-free license to display, distribute, and promote the event content on our Platform.
            </p>
          </section>

          {/* Section 5 */}
          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">5. Prohibited Conduct</h2>
            <p className="text-gray-700 leading-relaxed mb-3">You agree not to:</p>
            <ul className="list-disc pl-6 space-y-2 text-gray-700">
              <li>Use the Platform for fraudulent, harmful, or unlawful purposes.</li>
              <li>Impersonate any person or entity.</li>
              <li>Upload viruses, spam, or harmful code.</li>
              <li>Scrape, copy, or misuse event listings for commercial purposes without permission.</li>
            </ul>
          </section>

          {/* Section 6 */}
          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">6. Intellectual Property</h2>
            <p className="text-gray-700 leading-relaxed">
              All content, branding, logos, and software on the Platform (other than user-submitted events) are owned by The Daily Do and protected by intellectual property laws.
            </p>
          </section>

          {/* Section 7 */}
          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">7. Limitation of Liability</h2>
            <p className="text-gray-700 leading-relaxed mb-3">To the fullest extent permitted by law:</p>
            <ul className="list-disc pl-6 space-y-2 text-gray-700">
              <li>The Daily Do is not liable for any damages, losses, or injuries related to events, whether hosted by users, third parties, or otherwise.</li>
              <li>Our Platform is provided "as is" without warranties of any kind.</li>
            </ul>
          </section>

          {/* Section 8 */}
          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">8. Third-Party Links</h2>
            <p className="text-gray-700 leading-relaxed">
              Events or event pages may contain links to third-party sites. We are not responsible for the content, policies, or practices of these third parties.
            </p>
          </section>

          {/* Section 9 */}
          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">9. Termination</h2>
            <p className="text-gray-700 leading-relaxed">
              We reserve the right to suspend or terminate your access to the Platform if you violate these Terms.
            </p>
          </section>

          {/* Section 10 */}
          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">10. Governing Law</h2>
            <p className="text-gray-700 leading-relaxed">
              These Terms are governed by the laws of the United States, without regard to conflict of laws principles.
            </p>
          </section>
        </div>

        {/* Contact Section */}
        <div className="mt-8 pt-8 border-t border-gray-200">
          <p className="text-gray-600 text-sm">
            If you have any questions about these Terms & Conditions, please contact us.
          </p>
        </div>
      </div>
    </div>
  );
}
